<template>
  <div class="topBox media_box">
    <div class="">
      <div class="bg_image" >
        <img :src="bgImage" :style="{ transform: `translateX(${-scrollLeft}px)`}" alt="" />
      </div>
      <div class="box">
            <div class="title_box">
              <div class="title">
                <div class="Entitle">{{ Entitle }}</div>
                <div class="Cntitle">{{ Cntitle }}</div>
              </div>
            </div>

            <div class="text-content">
              <div class="box_width">
                <slot>
                  <!-- 默认内容 -->
                  <div class="default-text">
                    
                  </div>
                </slot>
              </div>
              
              <!-- 
                <p v-for="(item, index) in 100" :key="index">
                欢迎您使用约剑服务！约剑是广州约剑汇体育科技有限公司（以下简称本公司）所拥有和经营的产品。在使用和接受约剑相关产品和服务之前，请您务必仔细阅读本协议，我们珍视您在向我们提供您的个人信息时对我们的信任，我们将按照本隐私政策处理您的个人信息并保障您信息的安全。
              </p> -->
              
            </div>
            
            
          <!--
              <p >版本更新日期：2024年12月06日 </p>
              <p >版本生效日期：2024年12月06日</p>  -->
        </div>
      </div>
  </div>
</template>
  
  <script>
export default {
  name: "secondary",
  props:['bgImage','Entitle','Cntitle'],
  data() {
    return {
      // Entitle: "INTRODUCTION",
      // Cntitle: "约剑简介",
      // bgImage:"https://img.fencerspage.com/upload/oss/club/contest/20250313/194267d2870edef99.jpg",
      scrollLeft:0, // 横向滚动距离
      
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    // 标题栏获取横向滚动距离
    handleScroll() {
      this.scrollLeft = window.scrollX || window.pageXOffset;
    },
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$media_num: 1200px; // 屏幕宽度

.topBox {
  // background-color: #000;
}

.media_box {
  position: relative;
  width: 100vw;
  font-size: 0.88vw; //1
  // background-color: #000;

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    font-size: 10.6px; // 0.00885*$media_num
  }
}

.bg_image {
  position: fixed;
  top: 5vw;
  left: 50%;
  transform: translate(-50%);
  z-index: 1;
  width: 100%;

  @media only screen and (max-width:$media_num) {
    top:60px;
  }

  img {
    width: 100vw;

    @media only screen and (max-width: $media_num) {
      width: 1200px;
    }
  }
}

.box {
  width: 100%;
  // margin: 0 auto;
  position: relative;
  color: #fff;
  z-index: 99;



  .title_box{
    font-size: 5.8em;
    width: 100%;
    // height:50vw;
    height:40vw;
    display: flex;
    justify-content: center;
    align-items: center;
    

    @media only screen and (max-width: $media_num) {
      // height: 600px;
      height: 480px;
      font-size: 61px;
    }
  }


  .title {
    text-align: center;

    .Entitle {
      background: linear-gradient(to bottom, #fff 30%, transparent); /* 从上到下的渐变 */
      -webkit-background-clip: text; /* 兼容 WebKit 浏览器 */
      background-clip: text; /* 将背景裁剪到文字 */
      color: transparent; /* 字体颜色透明 */
      font-weight: 700;
    }

    .Cntitle {
      font-size:0.9em;
      color: #fff;
      font-weight: 700;
      letter-spacing:0.05em;
      margin-top: -0.4em;
    }
  }

  
  .text-content{
    background-color: #000;
    padding-top:4%;
    padding-bottom: 4%;
    // padding-top: 5em;
    // padding-bottom: 10em;
    // margin-top: 6em;

    .box_width{
      width: 71%;
      margin: 0 auto;

      @media only screen and (max-width: $media_num) {
        width: 850px;
        font-size: 10.6px; // 0.00885*$media_num
      }
    }

  } 
    
}
</style>
  